/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/display-name */
import React, {
  ClassAttributes,
  InputHTMLAttributes,
  ReactChild,
  ReactFragment,
  ReactPortal,
  forwardRef,
} from 'react'
import { JSX } from 'react/jsx-runtime'
import Autocomplete from 'react-autocomplete'

import { ENTER_MSG } from '../constants/rhybus-config'
import InputLabel from './input-label'

const InputText = forwardRef((inputProps: any, ref: any) => {
  return (
    <div className={inputProps?.formClassName}>
      {inputProps?.label && (
        <InputLabel
          className={inputProps?.inputProps?.className}
          currency={inputProps?.isCurrency}
          infoLabel={inputProps?.info}
          isinfoClassName={inputProps?.infoClassName}
          isinfoIcon={inputProps?.infoIcon}
          isinfoLabel={inputProps?.isInfo}
          label={inputProps?.label}
          labelProps={{ htmlFor: inputProps?.inputProps?.id }}
          mandatory={inputProps?.isMandatory}
        />
      )}
      {inputProps?.data ? (
        <div className='autocompleteinput'>
          <Autocomplete
            getItemValue={(item: any) => item}
            inputProps={{
              placeholder: inputProps?.inputProps?.placeholder,
            }}
            items={inputProps.value !== '' && inputProps.value?.length > 2 ? inputProps.data : []} //sets how many characters before autocomplete shows
            menuStyle={{
              background: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '3px',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
              fontSize: '90%',
              left: '0',
              maxHeight: '20em',
              overflow: 'auto',
              padding: '2px 0',
              position: 'absolute',
              top: '30px',
              width: '100%',
              zIndex: 100,
            }}
            onChange={inputProps.changeHandler}
            onSelect={inputProps.onSelect}
            ref={ref}
            renderInput={(
              props: ClassAttributes<HTMLInputElement> &
                InputHTMLAttributes<HTMLInputElement> &
                JSX.IntrinsicAttributes 
            ) => (
              <input
                {...props}
                aria-label={inputProps['aria-label'] || inputProps?.label}
                aria-required={inputProps?.isMandatory}
                className={`input ${inputProps?.className}`}
                disabled={inputProps?.disabled}
                id={inputProps?.inputProps?.id}
                max={inputProps?.type?.toLowerCase() === 'date' ? '2999-12-31' : undefined}
                maxLength={inputProps?.inputProps?.maxLength}
                name={inputProps?.inputProps?.name}
                placeholder={inputProps?.inputProps?.placeholder}
                readOnly={inputProps?.readonly}
                size={inputProps?.inputProps?.size || 'sm'}
                style={inputProps?.style}
                tabIndex={0}
                type={inputProps?.type || 'text'}
              />
            )}
            renderItem={(
              item: ReactChild | ReactFragment | ReactPortal | boolean | null | undefined,
              isHighlighted: any
            ) => (
              <div
                style={{
                  background: isHighlighted ? 'lightgray' : 'white',
                  padding: '5px',
                }}
                tabIndex={0}
              >
                {item}
              </div>
            )}
            shouldItemRender={(item: string, value: string) =>
              item?.toLowerCase()?.indexOf(value.toLowerCase()) > -1
            }
            value={inputProps.value}
            wrapperStyle={{
              display: 'block',
              position: 'relative',
              width: '100%',
            }}
          />
        </div>
      ) : (
        <>
          <input
            aria-label={inputProps['aria-label'] || inputProps?.label}
            aria-required={inputProps?.isMandatory}
            className={`input ${inputProps?.className}`}
            disabled={inputProps?.disabled}
            id={inputProps?.inputProps?.id}
            max={inputProps?.type?.toLowerCase() === 'date' ? '2999-12-31' : undefined}
            maxLength={inputProps?.inputProps?.maxLength}
            min={inputProps?.min}
            name={inputProps?.inputProps?.name}
            onBlur={inputProps?.blurHandler}
            onChange={inputProps?.changeHandler}
            placeholder={inputProps?.inputProps?.placeholder}
            readOnly={inputProps?.readonly}
            ref={ref}
            size={inputProps?.inputProps?.size || 'sm'}
            style={inputProps?.style}
            type={inputProps?.type || 'text'}
            value={inputProps?.inputProps?.value}
          />
          {inputProps?.icon && <span className={inputProps?.icon}></span>}
        </>
      )}
      {inputProps?.icon && <span className={inputProps?.icon}></span>}
      {inputProps?.data && inputProps?.error && (
        <span className='errormsg'>{'No matches found'}</span>
      )}
      {inputProps?.error && !inputProps?.data && !inputProps.uniqueErrormsg && (
        <span className='errormsg'>
          {ENTER_MSG} {inputProps?.label || inputProps['aria-label']}
        </span>
      )}
      {inputProps?.error && !inputProps?.data && inputProps.uniqueErrormsg && (
        <span className='errormsg'>{inputProps.uniqueErrormsg}</span>
      )}
      {inputProps?.errorMessage && <span className='errormsg'>{inputProps?.msg}</span>}
    </div>
  )
})
export default InputText
